function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import Vue from 'vue';
import { isNaN, isNumber } from '@cloud-sn/v-utils';
import Notification from '@cloud-sn/v-notification';
import Icon from '../icon';
var defaultProps = {
  // ms
  duration: 1500,
  top: undefined,
  prefixCls: 'ux-message',
  theme: 'light',
  transitionName: 'move-up',
  getContainer: null
}; // ms

var seed = 0;
var msgInst = null;
var MESSAGE_TYPES = [{
  type: 'info',
  icon: 'info_circle'
}, {
  type: 'success',
  icon: 'ok_circle'
}, {
  type: 'error',
  icon: 'close_circle'
}, {
  type: 'warning',
  icon: 'exclamation_circle'
}, {
  type: 'warn',
  icon: 'exclamation_circle'
}, {
  type: 'loading',
  icon: 'loading'
}];

var customProps = _objectSpread({}, defaultProps);

var Ctor = Vue.extend({
  components: {
    Icon: Icon
  }
});
var render = new Ctor();

function getMessageInstance() {
  var _customProps = customProps,
      prefixCls = _customProps.prefixCls,
      top = _customProps.top,
      transitionName = _customProps.transitionName,
      getContainer = _customProps.getContainer,
      theme = _customProps.theme;

  if (!msgInst) {
    msgInst = Notification.newInstance({
      prefixCls: prefixCls,
      notificationClass: ["".concat(prefixCls, "-").concat(theme)],
      notificationStyle: {
        top: isNaN(Number(top)) || top === null || top === '' ? top : "".concat(Number(top), "px")
      },
      transitionName: transitionName,
      getContainer: getContainer
    });
  }

  return msgInst;
}

function notice(_ref) {
  var iconType = _ref.iconType,
      type = _ref.type,
      _ref$content = _ref.content,
      content = _ref$content === void 0 ? '' : _ref$content,
      _ref$duration = _ref.duration,
      duration = _ref$duration === void 0 ? customProps.duration : _ref$duration,
      onClose = _ref.onClose,
      dangerouslySetInnerHTML = _ref.dangerouslySetInnerHTML,
      other = _objectWithoutProperties(_ref, ["iconType", "type", "content", "duration", "onClose", "dangerouslySetInnerHTML"]);

  var _customProps2 = customProps,
      prefixCls = _customProps2.prefixCls;
  var instance = getMessageInstance();
  var h = render.$createElement; // eslint-disable-line no-unused-vars

  var contentVNode = h("div", {
    "class": ["".concat(prefixCls, "-custom-content"), "".concat(prefixCls, "-").concat(type)]
  }, [h("icon", {
    "attrs": {
      "type": iconType
    }
  }), dangerouslySetInnerHTML ? h("span", {
    "domProps": {
      "innerHTML": content
    }
  }) : h("span", [content])]);
  var props = {
    $$id: "$$id-".concat(seed += 1),
    props: _objectSpread({}, other, {
      content: contentVNode,
      duration: duration
    }),
    onClose: onClose
  };
  instance.notice(props);
  return function () {
    instance.remove(props);
  };
}

var UxMessage = MESSAGE_TYPES.reduce(function (r, v) {
  var nr = r;

  nr[v.type] = function handle() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var nParams = params;

    if (typeof nParams === 'string') {
      nParams = {
        content: nParams
      };
    }

    nParams.type = v.type === 'warn' ? 'warning' : v.type;
    nParams.iconType = v.icon;
    return notice(nParams);
  };

  return r;
}, {});

UxMessage.config = function (_ref2) {
  var prefixCls = _ref2.prefixCls,
      getContainer = _ref2.getContainer,
      top = _ref2.top,
      duration = _ref2.duration,
      theme = _ref2.theme;

  if (prefixCls || typeof getContainer === 'function' || typeof top !== 'undefined' || theme !== customProps.theme) {
    UxMessage.destroy();
  }

  var props = {};

  if (typeof top !== 'undefined') {
    props.top = top;
  }

  if (isNumber(duration)) {
    props.duration = duration;
  }

  if (typeof getContainer === 'function') {
    props.getContainer = getContainer;
  }

  if (prefixCls) {
    props.prefixCls = prefixCls;
  }

  if (theme) {
    props.theme = theme;
  }

  customProps = _objectSpread({}, defaultProps, {}, props);
};

UxMessage.destroy = function () {
  if (msgInst) {
    msgInst.destroy();
    msgInst = null;
  }
};

export default UxMessage;